import { createApi } from '@reduxjs/toolkit/query/react';
import { createApiConfig } from '../../createApiConfig';

export const uMUserGroupsApi = createApi({
  reducerPath: 'uMUserGroupsApi',
  ...createApiConfig(process.env.REACT_APP_API_BASE_URL),
  endpoints: (builder) => ({
    listUserGroups: builder.query({
      query: (params) => ({
        url: `users/auth-user-groups/`,
        params,
      }),
    }),
    assignGroupToUser: builder.mutation({
      query: (data) => ({
        url: `users/auth-user-groups/`,
        method: 'POST',
        body: data,
      }),
    }),
    deleteGroupFromUser: builder.mutation({
      query: (id) => ({
        url: `users/auth-user-groups/${id}/`,
        method: 'DELETE',
      }),
    }),
    bulkDeleteGroupFromUser: builder.mutation({
      query: (data) => ({
        url: `users/auth-user-groups/`,
        method: 'DELETE',
        body: data,
      }),
    }),
  }),
});

export const {
  useListUserGroupsQuery,
  useAssignGroupToUserMutation,
  useDeleteGroupFromUserMutation,
  useBulkDeleteGroupFromUserMutation,
} = uMUserGroupsApi;
